
<div style="margin-left: 75px;">
    <c-app-bar
        title          = "Export Dokumente"
        :categories    = "[]"
        :enable-search = "false"
    >
        <template v-slot:search>
            <v-spacer />
        </template>
    </c-app-bar>
    <div
        style  = "height: 917px; margin-right: 75px;"
    >
        <div class="lm-border pa-3 v-flex" >
            <div class="v-flex" style="width: 50%">
                <v-form class="w-100" ref="form">
                    <v-row dense>
                        <v-col class="no-frame pr-2 col-5">
                            <f-enum-autocomplete
                                v-model = "customer"
                                label   = "Kunde"
                                module  = "msd"
                                type    = "limCustomer"
                                class   = "mb-2"
                                clearable
                                :rules         = "[ customerRequiredRule ]"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>

                        <v-col class="no-frame pl-2 pr-2 col-3">
                            <v-select
                                :items  = "types"
                                label   = "Dokumententyp"
                                :rules  = "[ customerRequiredRule ]"
                                v-model = "doctype"
                            />
                        </v-col>

                        <v-col class="no-frame pl-2 pr-2 col-2">
                            <f-date-picker
                                label   = "inc.docexport.interval.from"
                                :time   = "false"
                                :rules  = "[ customerRequiredRule ]"
                                v-model = "interval.from"
                            />
                        </v-col>
                        <v-col class="no-frame pl-2 col-2">
                            <f-date-picker
                                label   = "inc.docexport.interval.to"
                                :time   = "false"
                                :rules  = "[ customerRequiredRule ]"
                                v-model = "interval.to"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="no-frame">
                    </v-row>
                </v-form>
            </div>
            <div class="v-flex">
                <div class="primary mt-1 ml-2 tool-button">
                    <a @click="onValidate">
                        <div class="primary white--text pl-3 pr-3 pt-1 pb-1 tool-button">
                            Prüfen
                        </div>
                    </a>
                </div>
                <div class="primary mt-1 ml-2 tool-button" v-if="documents.filtered">
                    <a @click="onExport">
                        <div class="primary white--text pl-3 pr-3 pt-1 pb-1 tool-button">
                            Download
                        </div>
                    </a>
                </div>
            </div>
            <v-spacer />
            <div v-if="doctype === 'GBU'">
                <v-select
                    v-model="gbuSelection"
                    :items="gbuTypes"
                    label="GBU Dokumente"
                    multiple
                    hide-details
                    class="mt-0 pt-2"
                    style="max-width: 300px"
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 1">
                            {{ item }}
                        </span>
                        <span v-if="index === 1" class="grey--text text-caption ml-2">
                           (+{{ gbuSelection.length - 1 }} weitere)
                        </span>
                    </template>
                </v-select>
            </div>
            <div>
                <!-- Search criteria input -->
                <div class=" ml-3" v-if="documents.all">
                    <v-text-field
                        outlined
                        hide-details
                        dense
                        v-model="search"
                        clearable
                        clear-icon="mdi-close-circle"
                        append-icon="mdi-eye"

                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        style="width: 250px; padding-top: 0"
                    />
                </div>
                <!-- Search criteria input -->
            </div>
        </div>


        <div class="v-flex h-100 mt-2" style="position:relative;">
            <v-progress-linear
                v-if="exporting"
                style="position: absolute; top: -7px"
                indeterminate
                color="primary"
                height="6"
            />
            <div class="w-50 lm-border pa-3 h-100 mr-2">
                <c-column-header
                    v-if = "documents.all"
                    :label="'Dokumente - ' + doctype"
                    class="primary"
                >
                    <template v-slot:filter>
                        <div style="margin-top: -2px">
                            <c-toolbar-button
                                color  = "white"
                                size   = "22"
                                icon   = "mdi-arrow-expand-vertical"
                                @click = "onExpand"
                                tooltip = "alle Ordner öffnen"
                            />
                        </div>
                    </template>
                </c-column-header>
                <v-treeview
                    v-if          = "documents.filtered"
                    :items        = "documents.filtered"
                    item-children = "entries"
                    item-key      = "key"
                    :open.sync    = "open"
                    hoverable
                    dense
                    style="max-height: calc(100% - 34px);  overflow-y: scroll"
                    ref="treeview"
                >
                    <template v-slot:label="{ item, open }">
                        <div class="no-frame w-100">
                            <v-card  v-if="!item.filename"  flat @click = "onUnit(item)">
                                <v-row class="no-frame" >
                                    <v-col class="no-frame table-text" style="width: 25px; max-width: 25px">
                                        <v-icon
                                            size = "20"
                                            color="primary"
                                        >
                                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                        </v-icon>
                                    </v-col>
                                    <v-col class="no-frame table-text col-2">
                                        {{ item.fabricNo}}
                                    </v-col>
                                    <v-col class="no-frame table-text col-4">
                                        {{ item.zip}} {{ item.city}}
                                    </v-col>
                                    <v-col class="no-frame table-text">
                                        {{ item.street}}
                                    </v-col>
                                    <v-col class="no-frame table-text col-1" v-if="isMaintenance">
                                        {{ item.current}} von {{ item.count}}
                                    </v-col>
                                </v-row>
                            </v-card>

                            <v-card flat @click = "onRowClick(item)">
                                <v-row class="no-frame pl-1"  v-if="item.filename">
                                    <v-col class="no-frame table-text col-2" style="padding-top: 2px;" >
                                       <div :class="item.error ? 'error doc-status' : item.status ? 'success doc-status' : ''">
                                           {{ date (item.executiondate) }}
                                       </div>
                                    </v-col>
                                    <v-col class="no-frame table-text v-flex" >
                                        <div class="lm-border mr-2 incident-button v-flex" v-if="item.incidentId ">
                                            <div style="margin-top: -2px">
                                                <c-toolbar-button
                                                    icon="mdi-pen"
                                                    size="14"
                                                    color="primary"
                                                    tooltip="Ereignis bearbeiten"
                                                    @click="onIncident(item.incidentId)"
                                                />
                                            </div>
                                            <div>
                                                {{ item.incidentId }}
                                            </div>
                                        </div>
                                        <div class="w-100 v-flex" :class="document && document.id === item.id ? 'primary pl-1 pr-1 doc-status' : ''">
                                            <div style="padding-top: 1px;" :class="isIgnored (item) ? 'grey--text' : ''">
                                                {{ item.hint? (item.hint + " - " + item.name ) : item.name}}
                                            </div>
                                            <v-spacer />
                                            <v-btn
                                                v-if="isAssignable(item)"
                                                @click="onAssign"
                                                color="white"
                                                class="mr-1"
                                                x-small
                                                style="margin-top: 2px"
                                            >
                                                <v-icon color="warning" size="20">mdi-arrow-left-bold</v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-if="isDeleteable(item)"
                                                @click="onDelete"
                                                color="white"
                                                x-small
                                                style="margin-top: 2px"
                                            >
                                                <v-icon color="error" size="20">mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </div>
                     </template>
                </v-treeview>
            </div>

            <div class="w-50">
                <div class="w-100 lm-border pa-3 pb-2" style="height: 50%" v-if="isMaintenance && isElo(document)">
                    <div v-if="(document || dmsDocument) && !folder">
                        <v-progress-linear
                            indeterminate
                            color="primary"
                            height="8"
                        />

                        <div class="elo-dir-loading primary--text">
                            Die ELO Dokumente zur Anlage {{ unitId }} werden ermittelt ...
                        </div>
                    </div>
                    <c-dms-folder-info
                        class     = "h-100"
                        :folder   = "folder"
                        :selected = "dmsDocument"
                        :from     = "interval.from"
                        :to       = "interval.to"
                        @selected = "onDmsSelected"
                    />
                </div>

                <div
                    class="w-100 lm-border pa-3 "
                    :style="isMaintenance && isElo(document) ? 'height: calc(50% - 8px)' : 'height:100%'"
                    :class="isMaintenance && isElo(document) ? 'mt-2' : 'mt-0'"
                >
                    <c-dms-viewer
                        v-if="(document && !document.id.startsWith('--')) || dmsDocument"
                        style="height: 100%"
                        :document = "selectedDocument"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
